import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { withDefaults } from 'vue'
import SubMenuItem from './SubMenuItem.vue'
interface Props {
    menuData: Record<string, any>[],
    defaultActive:number,
    isZh:boolean,
    selctFun:(menuId:string)=>void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuItem',
  props: {
    menuData: { default: () => [] },
    defaultActive: { default: 0 },
    isZh: { type: Boolean, default: true },
    selctFun: null
  },
  setup(__props: any) {

const props = __props as { menuData: Record<string, any>[], defaultActive:number, isZh:boolean, selctFun:(menuId:string)=>void };




return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!

  return (__props.menuData.length)
    ? (_openBlock(), _createBlock(_component_el_menu, {
        key: 0,
        "default-active": __props.defaultActive+'',
        onSelect: __props.selctFun
      }, {
        default: _withCtx(() => [
          _createVNode(SubMenuItem, {
            menuData: __props.menuData,
            isZh: __props.isZh
          }, null, 8, ["menuData", "isZh"])
        ]),
        _: 1
      }, 8, ["default-active", "onSelect"]))
    : _createCommentVNode("", true)
}
}

})